import React from 'react';
import './data-card.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DataCard = ({
    icon,
    data,
    text,
    onclick,
    role
}) => {
    return (
        <>
            {
                (onclick) 
                ?
                <button 
                    className='g-button g-list-item'
                    onClick={onclick}
                >
                    <div className='data-card'>
                        <div className='icon-circle'>
                            <FontAwesomeIcon icon={icon} size='xl' />
                        </div>
                        <div className='data-div'>
                            <div className='data-number'>
                                {data}
                            </div>
                            <div className='data-text'>
                                {text}
                            </div>
                        </div>
                    </div>
                </button>
                :
                <div className='g-button g-list-item disabled'>
                    <div 
                        className='data-card'
                    >
                        <div className='icon-circle'>
                            <FontAwesomeIcon icon={icon} size='xl' />
                        </div>
                        <div className='data-div'>
                            <div className='data-number'>
                                {data}
                            </div>
                            <div className='data-text'>
                                {text}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default DataCard